import { GFFieldComponentProps } from "eddev/integrations/gravityforms"
import { Select } from "./Select"
import { Input } from "./Input"

export type choice = {
  isSelected: boolean
  text: string
  value: string
}

type Props = GFFieldComponentProps<"name">

export function NameGroup(props: Props) {
  return (
    <div className={`flex flex-row gap-3 w-full ${Object.values(props.subfields).length > 3 ? `` : ``}`}>
      {Object.values(props.subfields).map((input) => {
        if (!input.visible) return null

        return (
          <div key={input.name} className="flex flex-grow">
            {input.choices ? (
              <div className="flex flex-col gap-2 w-full">
                <Select
                  choices={input.choices}
                  onChange={(e: any) => {
                    console.log(e)
                    props.set({ ...props.value, [input.name]: e.currentTarget.value })
                  }}
                  value={props.value?.[input.name] ?? ""}
                />
                <label className="type-label-s text-text">{input.label}</label>
              </div>
            ) : (
              <div className="flex flex-col gap-2 w-full">
                <Input
                  value={props.value?.[input.name] ?? ""}
                  onChange={(e: any) => props.set({ ...props.value, [input.name]: e.currentTarget.value })}
                />
                <label className="type-label-s text-text">{input.label}</label>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
